import { SalesOrderComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1321. 受注案件コメントリアクションtoggle
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  emoji_id: string;
  content: string;
};
const salesOrderCommentReaction = (props: Props): Promise<SalesOrderComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_comments/${props.id}/reactions`,
    props
  );
};
export const useSalesOrderCommentReaction = () => {
  return useMutation({
    mutationFn: salesOrderCommentReaction,
  });
};
